<!--
 * @Description:
 * @Author: KING
 * @Date: 2022-04-02 09:32:57
 * @LastEditors: lgg
 * @LastEditTime: 2022-04-22 16:45:07
-->
<template>
  <div style="text-align: center">
    <img src="../../assets/images/tips.png" />

    <p style="color: #30c80e; margin-top: 0px" v-if="returnMessage">{{ returnMessage }}</p>
    <p style="color: #30c80e; margin-top: 0px" v-else>提交成功</p>
    <div v-if="dataList && dataList.length > 0" class="stepDiv">
      <div class="titleDiv">
        <p>下一审核流程</p>
      </div>
      <div class="messDiv">
        <p v-for="(item, index) in dataList" :key="index">
          任务名称：<strong>{{ item.taskName }}</strong
          >&nbsp;&nbsp;&nbsp;&nbsp; 审批人：<strong>{{ item.taskUsers }}</strong>
        </p>
      </div>
    </div>
    <p>
      <font color="#1890FF">{{ timeNum }}</font>
      <font color="#CCCCCC">秒后自动返回</font>
    </p>
    <el-button style="width: 150px; font-size: 20px" type="primary" round @click="goBack()"
      >立即返回</el-button
    >
  </div>
</template>

<script>
export default {
  name: 'tipsView',
  components: {},
  props: {
    dataList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    returnMessage: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      timer: '',
      timeNum: 10
    };
  },

  computed: {},

  created() {
    this.createInterval();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    createInterval() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timeNum = 10;
      this.timer = setInterval(() => {
        this.timeNum--;
        if (this.timeNum <= 0) {
          history.go(-1);
        }
      }, 1000);
    },
    goBack() {
      // clearInterval(this.timer);
      this.$emit('closeTips', false);
    }
  }
};
</script>

<style>
.el-step__description.is-process {
  color: #303133;
  font-size: 15px;
}

.el-step__description.is-wait {
  color: #c0c4cc;
  font-size: 15px;
}

.titleDiv {
  width: 100px;
}

.stepDiv {
  width: 500px;
  max-height: 120px;
  display: flex;
  margin: 0 auto;
}

.messDiv {
  width: 400px;
  overflow: auto;
}
</style>
